import React from 'react'
import { Card, CardHeader, CardText } from 'material-ui/Card'
import FontIcon from 'material-ui/FontIcon'

import './simpleCard.scss'

export default ({ title, children, className, info, link = '' }) => (
  <Card className={`simpleCard ${className}`}>
    <CardHeader className="simpleCard__title flex-center--space-between">
      <h4>{title}</h4>
      {info &&
        <a href={link} target="_blank" style={{height: 26}}>
          <FontIcon className="material-icons medium-spacing2--left" style={{color: "#FFFFFF", fontSize: 26}}>info_outline</FontIcon>
        </a>
      }
    </CardHeader>
    <CardText className="simpleCard__body">{children}</CardText>
  </Card>
);



// WEBPACK FOOTER //
// ./app/components/SimpleCard.js